<template>
    <el-dialog :visible.sync="dialogFormVisible" v-mobile-dialog
               :close-on-click-modal="false" :before-close="handleClose">

        <div slot="title"><b class="text-info">{{single.name}}</b> </div>
        <el-row :gutter="20">
            <el-col :span="24">
                <div class="d-flex">
                    <div class="page-label">姓名:</div>
                    <div class="page-content">{{single.name}}</div>
                </div>
            </el-col>
            <el-col :span="24">
                <div class="d-flex">
                    <div class="page-label">账号:</div>
                    <div class="page-content">{{single.user_id}}</div>
                </div>
            </el-col>
            <el-col :span="24">
                <div class="d-flex">
                    <div class="page-label">邮箱:</div>
                    <div class="page-content">{{single.email}}</div>
                </div>
            </el-col>
        </el-row>

        <el-row :gutter="20">
            <el-col :span="24">
                <div class="d-flex">
                    <div class="page-label">部门:</div>
                    <div class="page-content">{{single.department}}</div>
                </div>
            </el-col>
            <el-col :span="24">
                <div class="d-flex">
                    <div class="page-label">申请时间:</div>
                    <div class="page-content">{{single.created_at}}</div>
                </div>
            </el-col>
        </el-row>

        <div v-if="btn_approve">
            <el-form :inline="true" :model="approve_form" class="approve_form">
                <el-form-item label="审批结果">
                    <el-select size="mini" v-model="approve_form.approve_result" placeholder="选择审批结果">
                        <el-option label="审批通过" value=2></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
        </div>

        <div slot="footer" class="dialog-footer">
            <el-button v-if="btn_approve" type="success" @click="handleApprove">审批通过</el-button>
            <el-button type="primary" @click="$emit('cancel')">取 消</el-button>
        </div>
    </el-dialog>
</template>

<script>

    export default {
        name: "visitor-view",
        data() {
            return {
                dialogFormVisible: false,
                approve_form:{approve_result:'2'},
                qrcode:null,
            }
        },
        components:{},
        props: {
            view_mode: {
                type: Boolean,
                default() {
                    return false;
                }
            },
            single: {
                type: Object,
                default() {
                    return {};
                }
            },
            btn_start_meeting: {
                type: Boolean,
                default() {
                    return true;
                }
            },
            btn_approve: {
                type: Boolean,
                default() {
                    return false;
                }
            },

        },
        watch: {
            view_mode: {
                handler(newVal) {
                    this.dialogFormVisible = newVal;
                }
            },
        },
        methods: {
            handleClose(done) {
                done();
                this.$emit('cancel');
            },
            handleApprove(){
                if (this.approve_form.approve_result > 0) {
                    if (!this.approve_form.reject_reason && this.approve_form.approve_result == 1) {
                        this.$messageBox.error('请填写拒绝理由!');
                    } else {
                        this.$emit('approve',this.approve_form);
                    }
                }
            }
        }
    }
</script>

<style lang="scss">
    .approve_form {
        margin-top: 20px;
        padding: 10px 20px 5px;
        background-color: #FFFDE7;
        text-align: center;

        .el-form-item {
            margin-bottom: 0;
        }
    }

</style>
